var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.summary)?_c('SummaryEvent',{attrs:{"event":_vm.event}}):_c('DetailEvent',{attrs:{"event":_vm.event}},[(_vm.event.wasAutomaticallyApproved())?_c('img',{staticClass:"tw-w-10 leavedates-header-logo",attrs:{"src":require("@/assets/icons/logo.svg"),"alt":"leavedates-logo"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }